import React from 'react'
import {
  MarkerProps as GoogleMapsMarkerProps,
  Marker as GoogleMapsMarker,
} from '@react-google-maps/api'

const IMAGE_SRC = 'https://i.imgur.com/1v17tX1.png'

export interface MarkerProps extends GoogleMapsMarkerProps {}

export const Marker = ({ position, ...restProps }: MarkerProps) => {
  return <GoogleMapsMarker position={position} icon={IMAGE_SRC} {...restProps} />
}

export default Marker
